import { useMemo } from 'react';
import { useSetUpList } from '../../../hooks/queries/setUpQueries';
import SystemSetUpItem from './SystemSetUpItem';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { hasFeatureAccess } from '../../../utils/permissions';
import { FEATURES, ROUTES } from '../../../utils/constants';
import SystemSetUpCblEditModal from './SystemSetUpCblEditModal';
import SystemSetUpChargingDemandPredictionEditModal from './SystemSetUpChargingDemandPredictionEditModal';
import { isSystemAdmin } from '../../../utils/permissions';
const SystemSetUp = () => {
  const { data: setUpData, refetch: refetchSetUpList } = useSetUpList();

  const [isCblEditModalOpen, setIsCblEditModalOpen] = useState(false);
  const [isChargingDemandPredictionEditModalOpen, setIsChargingDemandPredictionEditModalOpen] = useState(false);
  const navigate = useNavigate();
  
  // 시스템 구성 키 관리 페이지 접근 권한 확인
  const hasConfigKeyManagementAccess = isSystemAdmin();
  // Group 필드를 기준으로 Items를 그룹화
  const groupedData = useMemo(() => {
    if (!setUpData?.Items || !Array.isArray(setUpData.Items)) {
      return {};
    }

    return setUpData.Items.reduce((acc, item) => {
      const groupName = item.Group || '기타';
      if (!acc[groupName]) {
        acc[groupName] = [];
      }
      acc[groupName].push(item);
      return acc;
    }, {});
  }, [setUpData]);

  // 그룹화된 데이터의 키 배열 (그룹 이름들)
  const groupNames = useMemo(() => {
    return Object.keys(groupedData);
  }, [groupedData]);

  const onCloseCblEditModal = () => {
    setIsCblEditModalOpen(false);
    refetchSetUpList();
  }
  const onCloseChargingDemandPredictionEditModal = () => {
    setIsChargingDemandPredictionEditModalOpen(false);
    refetchSetUpList();
  }
  return (
    <>
      <div className="flex justify-end gap-3">
        {hasConfigKeyManagementAccess && (
          <button 
            className="btn big-btn btn-style-5 flex align-center gap-3" 
            onClick={() => navigate(ROUTES.SYSTEM_CONFIG_KEY_MANAGEMENT)}
          >
            시스템 구성 키 관리
          </button>
        )}
      </div>
      <div className="system-setup-group-container">
        {groupNames.length === 0 ? (
          <div className="text-center text-gray-500">설정 데이터가 없습니다.</div>
        ) : (
          groupNames.map((groupName) => (
            groupName === 'DefaultCBL' ? (
            <div key={groupName} className="system-setup-group flex flex-col gap-10">
              <div className='flex align-center gap-10'>
                <p className="text-h2 text-gray-700">{groupName}</p>
                <button className="btn big-btn btn-style-5" onClick={() => setIsCblEditModalOpen(true)}>
                  CBL 연산 모듈 수정
                </button>
              </div>
              <div className="system-setup-group-content flex flex-col gap-20 p-20">
                {groupedData[groupName].map((item, index) => (
                  <div key={`${item.Group}-${item.Key}-${index}`} className="system-setup-item-wrapper flex flex-col gap-4">
                    <SystemSetUpItem 
                      item={item}
                      mode={groupName === 'DefaultCBL' ? 'cbl' : 'default'}
                      disabled={!hasConfigKeyManagementAccess}
                    />
                  </div>
                ))}
              </div>
            </div>
          ) :
          groupName === 'ChargingDemandAi' ? (
            <div key={groupName} className="system-setup-group flex flex-col gap-10">
              <div className='flex align-center gap-10'>
                <p className="text-h2 text-gray-700">{groupName}</p>
                <button className="btn big-btn btn-style-5" onClick={() => setIsChargingDemandPredictionEditModalOpen(true)}>
                  일일 충전량 예측 모듈 수정
                </button>
              </div>
              <div className="system-setup-group-content flex flex-col gap-20 p-20">
                {groupedData[groupName].map((item, index) => (
                  <div key={`${item.Group}-${item.Key}-${index}`} className="system-setup-item-wrapper flex flex-col gap-4">
                    <SystemSetUpItem 
                      item={item}
                      mode={groupName === 'ChargingDemandAi' ? 'cbl' : 'default'}
                      disabled={!hasConfigKeyManagementAccess}
                    />
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div key={groupName} className="system-setup-group flex flex-col gap-10">
              <p className="text-h2 text-gray-700">{groupName}</p>
              <div className="system-setup-group-content flex flex-col gap-20 p-20">
                {groupedData[groupName].map((item, index) => (
                  <div key={`${item.Group}-${item.Key}-${index}`} className="system-setup-item-wrapper flex flex-col gap-4">
                    <SystemSetUpItem 
                      item={item}
                      disabled={!hasConfigKeyManagementAccess}
                    />
                  </div>
                ))}
              </div>
            </div>
          )
        ))
        )}
      </div>
      
      {isCblEditModalOpen && (
        <SystemSetUpCblEditModal onClose={() => setIsCblEditModalOpen(false)} onSuccess={onCloseCblEditModal} />
      )}
      {isChargingDemandPredictionEditModalOpen && (
        <SystemSetUpChargingDemandPredictionEditModal onClose={onCloseChargingDemandPredictionEditModal} onSuccess={onCloseChargingDemandPredictionEditModal} />
      )}
    </>
  );
};

export default SystemSetUp;